/** @file makeError: the error throwError would throw, returned instead (for rejections and mapping). */
import type { ErrorContext } from '@zilo/pose3d-std/errors/throwError';
import { throwError } from '@zilo/pose3d-std/errors/throwError';
import type { Pose3DError } from '@zilo/pose3d-std/errors/pose3DError';
import { toPose3DError } from '@zilo/pose3d-std/errors/toPose3DError';

/** An `Error` carrying the Pose3DError fields, built by std's `throwError` so both stay one shape. */
export function makeError(code: string, params: Record<string, unknown> = {}, ctx: ErrorContext = {}): Pose3DError & Error {
  try {
    return throwError(code, params, ctx);
  } catch (e) {
    if (toPose3DError(e) === null || !(e instanceof Error)) throw e;
    return e as Pose3DError & Error;
  }
}
